// The device's playback volume (recordings/volume.ts): the full row in Asetukset → Ääni, and a
// compact slider beside players where there is room (never in the study thumb zone).
import { useId, useSyncExternalStore } from 'react';
import { Icon } from '../components/Icon';
import { useT } from '../i18n';
import { getVolume, setVolume, subscribeVolume } from './volume';
import './recordings.css';

export function useVolume(): number {
  return useSyncExternalStore(subscribeVolume, getVolume, () => 1);
}

export function VolumeControl({ compact }: { compact?: boolean }) {
  const t = useT();
  const E = t.recEdit;
  const v = useVolume();
  const id = useId();
  const pct = Math.round(v * 100);
  const input = (
    <input
      id={id}
      type="range"
      className="vol-range"
      min={0}
      max={100}
      step={5}
      value={pct}
      aria-valuetext={E.volumeValue(pct)}
      {...(compact ? { 'aria-label': E.volume } : {})}
      onChange={(e) => setVolume(Number(e.target.value) / 100)}
    />
  );
  if (compact) {
    return (
      <span className="vol is-compact" title={`${E.volume} ${E.volumeValue(pct)}`}>
        <Icon name="volume" size={18} />
        {input}
      </span>
    );
  }
  return (
    <div className="field-row vol">
      <label className="field-label" htmlFor={id}>
        {E.volume}
      </label>
      <span className="vol-line">
        <Icon name="volume" size={18} />
        {input}
        <span className="vol-value tnum" aria-hidden="true">
          {E.volumeValue(pct)}
        </span>
      </span>
    </div>
  );
}
